import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { InfoOption } from '../../components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'investment-objective-form',
    templateUrl: './investment-objective-form.component.html',
    styleUrls: ['./investment-objective-form.component.scss'],
    standalone: false
})
export class InvestmentObjectiveFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = [];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
    this.options =
      this.subscriptionFacade?.getPledgeOptions()?.investmentGoalsOptions;
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    this.form

      .get('investmentGoals')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(value => {
        if (value && !value.includes('GENERATE_GARANTY')) {
          this.form.get('investmentGoalGarantyLender').setValue(null);
          this.form.get('investmentGoalGarantyObject').setValue(null);
        }
        if (value && value.includes('OTHER')) {
          this.form.get('investmentGoalDetail').setValue(null);
        }
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  check(item) {
    return (
      item == 'GENERATE_GARANTY' &&
      this.form.get('investmentGoals')?.value?.includes('GENERATE_GARANTY')
    );
  }
  check2(item) {
    return (
      item == 'OTHER' &&
      this.form.get('investmentGoals')?.value?.includes('OTHER')
    );
  }
}
